import {
    documents,
    time,
    person,
    clipboard,
    car,
    copy,
    ticket,
    wallet,
    card,
    people,
    book,
    informationCircle,
    documentText,
    listCircle,
    hourglass,
    newspaper,
    calendar,
    cube,
    home,
    list,
    barcode,
    shareSocial,
} from "ionicons/icons";

//Chiave localsotrage
const LOCALSTORAGE_KEY = `user${process.env.VUE_APP_LOCALSTORAGE_KEY}`;

// Pagina da vedere dopo il login
const getPageAfterLogin = () => {
    try {
        const userData = JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY));
        
        // Se l'utente è un tecnico ascensori (dipendenti_tipologia = 13), va ai rapportini
        if (userData && userData.dipendenti_tipologia && userData.dipendenti_tipologia == 13) {
            return "rapportini";
        }
        
        // Altrimenti va alle presenze (comportamento di default)
        return "presenze";
    } catch (error) {
        console.error("Errore nel recupero dei dati utente:", error);
        return "presenze"; // Fallback di default
    }
};

// Manteniamo anche la costante per compatibilità con codice esistente
const pageAfterLogin = "presenze";

// Pulsanti presenti nella dashboard
const dashbordButtons = {
    presenze: true,
    documenti: true,
    richieste: true,
    automezzi: true,
    spese: true,
    tickets: true,
};


/**
 *
 * RAPPORTINI
 *
 */
// Configurazione tab rapportini in dettaglio commessa
const showRapportiniTab = true;

// Configurazione del menu
const config_menu = [
    {
        show: true,
        route: "presenze",
        icon: time,
        name: "Presenze",
        allowedRoles: ["Admin", "Employee", "Impiegati", "Utenti APP", "Capo Commessa", "Assistente capo commessa", "Tecnico ascensori"],
    },
    {
        show: true,
        route: "documenti",
        icon: documents,
        name: "Documenti",
        allowedRoles: ["Admin", "Employee", "Impiegati", "Utenti APP", "Capo Commessa", "Assistente capo commessa", "Tecnico ascensori"],
    },
    {
        show: true,
        route: "richieste",
        icon: clipboard,
        name: "Richieste",
        allowedRoles: ["Admin", "Employee", "Impiegati", "Utenti APP", "Capo Commessa", "Assistente capo commessa", "Tecnico ascensori"],
    },
    {
        show: false,
        route: "banca",
        icon: hourglass,
        name: "Banca ore",
        allowedRoles: ["Admin", "Employee", "Impiegati", "Utenti APP", "Capo Commessa", "Assistente capo commessa"],
    },
    {
        show: false,
        route: "automezzi",
        icon: car,
        name: "Automezzi",
        allowedRoles: ["Admin"],
    },
    {
        show: false,
        route: "spese",
        icon: wallet,
        name: "Note spesa",
        allowedRoles: ["Admin"],
    },
    {
        show: false,
        route: "calendario",
        icon: calendar,
        name: "Calendario",
        allowedRoles: ["Admin"],
    },
    {
        show: false,
        route: "rimborsi",
        icon: card,
        name: "Rimborsi km",
        allowedRoles: ["Admin"],
    },
    {
        show: false,
        route: "clienti",
        icon: people,
        name: "Anagrafiche",
        allowedRoles: ["Admin"],
    },
    {
        show: false,
        route: "progetti",
        icon: listCircle,
        name: "Progetti",
        allowedRoles: [],
    },
    {
        show: false,
        route: "leads",
        icon: book,
        name: "Leads",
        allowedRoles: ["Admin"],
    },
    {
        show: false,
        route: "interventi",
        icon: documentText,
        name: "Interventi",
        allowedRoles: ["Admin"],
    },
    {
        show: true,
        route: "rapportini",
        icon: documentText,
        name: "Rapportini",
        allowedRoles: ["Admin", "Tecnico ascensori"],
    },
    {
        show: false,
        route: "tickets",
        icon: ticket,
        name: "Tickets",
        allowedRoles: ["Admin"],
    },
    {
        show: false,
        route: "task",
        icon: home,
        name: "Tasks",
        allowedRoles: ["Admin"],
    },
    {
        show: false,
        route: "timesheet",
        icon: time,
        name: "Timesheet",
        allowedRoles: ["Admin"],
    },
    {
        show: false,
        route: "bacheca",
        icon: shareSocial,
        name: "Bacheca",
        allowedRoles: ["Admin"],
    },
    {
        show: false,
        route: "programma",
        icon: calendar,
        name: "Programma lavoro",
        allowedRoles: [],
    },
    {
        show: false,
        route: "ordini",
        icon: cube,
        name: "Ordini interni",
        allowedRoles: ["Admin"],
    },
    {
        show: false,
        route: "sondaggi",
        icon: newspaper,
        name: "Sondaggi",
        allowedRoles: ["Admin"],
    },
    {
        show: false,
        route: "magazzino",
        icon: barcode,
        name: "Magazzino",
        allowedRoles: ["Admin"],
    },
    {
        show: false,
        route: "movimenti",
        icon: barcode,
        name: "Movimenti",
        allowedRoles: ["Admin"],
    },
    {
        show: false,
        route: "todo",
        icon: list,
        name: "Liste",
        allowedRoles: ["Admin"],
    },
    /* {
        show: true,
        route: "testbarcode",
        icon: list,
        name: "TestBarcode",
        allowedRoles: ['Admin', 'Employee']
    }, */
    
    {
        show: true,
        route: "profilo",
        icon: person,
        name: "Profilo",
        allowedRoles: ["Admin", "Employee", "Impiegati", "Utenti APP", "Capo Commessa", "Assistente capo commessa", "Tecnico ascensori"],
    },
];

/**
 *
 * RAPPORTINI
 *
 */
// Configurazione operatori e prodotti
const showOperatori = true;
const showProdotti = true;

/**
 *
 * TIMESHEET
 *
 */
// Configurazione input field da mostrare in creazone
const showTimesheetDateHour = false;

// Configurazione dei permessi per ruolo
const rolePermissions = {
    Admin: [
        "login",
        "presenze",
        "documenti",
        "richieste",
        "profilo",
        "changePassword"
    ], // '*' indica accesso a tutte le rotte
    Employee: [
        "login",
        "presenze",
        "documenti",
        "richieste",
        "profilo",
        "changePassword"
    ],
    "Sales Agent": [
        "login",
        "presenze",
        "documenti",
        "richieste",
        "profilo",
        "changePassword"
    ],
    "Tecnico ascensori": [
        "login",
        "presenze",
        "documenti",
        "richieste",
        "rapportini",
        "profilo",
        "changePassword"
    ],
};

export { LOCALSTORAGE_KEY, pageAfterLogin, getPageAfterLogin, dashbordButtons, config_menu, showProdotti, showOperatori, showTimesheetDateHour, showRapportiniTab, rolePermissions };
